import { serializeQuery } from './api.utils'
import { BaseApi } from './base.api'

export class OrderApi extends BaseApi {
	constructor() {
		super('api/admin/order')
	}

	async getAll(data) {
		const query = serializeQuery(data)
		const rs = await this.get(`?${query}`)
		return rs
	}
	async create(data) {
		const rs = await this.post('', data)
		return rs
	}
	async confirmOrder(data) {
		const rs = await this.post('/confirm', data)
		return rs
	}
}
